<div *ngIf="tiempoEspera?.onWaitlist" class="card" [ngClass]="'border-card-ondemand'" style="min-height: 250px;">
    <div class="card-header p-0">
        <div class="row p-0">
            <span class="badge badge-primary align-self-start badge-color-ondemand">
                Atención Inmediata
            </span>

            <app-popover *ngIf="options_bool" [color]="popoverColor" >
                <a (click)="mostrarModal('salir')">
                  <p>Salir de la fila</p>
                </a>
            </app-popover>
        </div>
    </div>
    <div class="card-body row">
        <div class="col-12 p-0" style="display: flex;align-items: center;">
            <p class="card-text doc-data" style="font-family: 'Mulish'; font-weight: 700;">
                {{ fechaTexto }}
            </p>
            <br>
            <p></p>
        </div>
        <div class="col-12 p-0" style="display: flex; align-items: center;">
            <p class="subText" *ngIf="isLoading == false">
              {{ messajeCard }}
            </p>
            <div class="loader"  *ngIf="isLoading == true">
              <div class="loader__figure"  style="border: 0 solid #2BABB7;"></div>
              <p class="loader__label"></p>
            </div>
        </div>

        <div class="col-12" style="display: flex; align-items: flex-end;">
            <div class="row p-0">
                <div class="col-6 p-0">
                    <div style="width: 100%;">
                        <button *ngIf="tiempoEspera.consulta.med_con_id != null" type="button"
                            class="btn btn-primary mr-auto boton-ondemand" (click)="goLobby()">
                            Ir a la sala de espera
                        </button>
                        <button *ngIf="tiempoEspera.consulta.med_con_id == null" type="button"
                            class="btn btn-primary mr-auto boton-ondemand" (click)="goLobby()">
                            Ir a la fila de espera
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



<!-- Backdrop Oscuro -->
<div class="modal-backdrop" *ngIf="modalActual === 'salir'" (click)="$event.stopPropagation()"></div>

<!-- Modal Salir de Fila (Primero) -->
<div class="modal-backdrop-common" *ngIf="modalActual === 'salir'" (click)="cerrarModal()">
    <div class="modal-common-content" (click)="$event.stopPropagation()">
        <h2 class="modal-title">¿Deseas salir de la fila de atención inmediata?</h2>
        <p class="modal-reason">{{ cancelMsg1 }}</p>
        <p class="modal-reason">{{ cancelMsg2 }}</p>
        <p class="modal-reason2">Selecciona un motivo para continuar con la anulación:</p>        
  
      <form [formGroup]="salirFilaForm">
        <div class="form-group">
          <select class="form-control" id="razonSelect" formControlName="reason">
            <option value="" disabled selected>Selecciona un motivo</option>
            <option *ngFor="let razon of cancelReason" [value]="razon.id_reason">
              {{ razon.reason_name }}
            </option>
          </select>
        </div>
      </form>
      <div *ngIf="salirFilaForm.value.reason == 1" class="col-md-12 col-sm-12 d-flex align-items-center justify-content-between p-2"
                style="background-color: #eaf4ff; border-radius: 12px; box-shadow: 0 2px 6px rgba(0,0,0,0.1);">
            <div class="row" style="display: flex
            ;
                align-items: center;">
                <div class="col-md-2 col-sm-2">
                    <mat-icon style="color: #171994; font-size: 28px; margin-right: 10px;">info</mat-icon>
                </div>
                <div class="col-md-5 col-sm-2" style="font-family: 'Mulish'; margin-bottom: 10px; padding: 0;">
                    <span >Si prefieres, puedes <b style="font-weight: 700;">reservar una hora con </b>uno de nuestros médicos.</span>
                </div>
                <div class="col-md-5 col-sm-12 p-0">
                    <!-- Botón -->
                    <button (click)="reservaHora()" type="button" class="btn btn-primary px-4" style="border-radius: 20px; font-weight: bold; background-color: #316AD8; font-size: 14px;">
                        Agendar ahora
                    </button>

                </div>
            </div>
        </div>
  
      <div class="buttons-box row">
        <div class="col">
          <button mat-button class="btn-secondary" (click)="cerrarModal()">
            <p class="m-0" style="font-weight: 600;">Volver</p>
          </button>
        </div>
        <div class="col">
          <button mat-raised-button class="btn-primary-cancel" style="border: 2px solid #2F7586 !important;" color="primary"
                  (click)="abrirConfirmacionSinDevolucion()" [disabled]="salirFilaForm.invalid">
            <p class="m-0" style="font-weight: 600;">Aceptar</p>
          </button>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Modal 2: Confirmación final -->
  <div class="modal-backdrop-common" *ngIf="modalActual === 'confirmarSinDevolucion'" (click)="cerrarModal()">
    <div class="modal-common-content" (click)="$event.stopPropagation()">
        <h2 class="modal-title">Confirmación de salida</h2>
        <p class="modal-reason">
          Vas a salir de la fila de espera de atención inmediata. Al salir, perderás tu lugar y deberás ingresar nuevamente si deseas ser atendido.        </p>
        
  
      <div class="buttons-box row">
        <div class="col">
          <button mat-button class="btn-secondary" (click)="cerrarModal()">
            <p class="m-0" style="font-weight: 600;">Cancelar</p>
          </button>
        </div>
        <div class="col">
          <button mat-raised-button class="btn-primary-cancel" style="border: 2px solid #2F7586 !important;" (click)="salirDeFila()" [disabled]="isLoadingExitFila">
            <p class="m-0" style="font-weight: 600;">Aceptar</p>
          </button>
        </div>
      </div>
    </div>
  </div>